// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable[data-v-6611a79a] {\n  border-collapse: collapse;\n  border: 1px solid black;\n  margin-bottom: 2rem;\n}\ntr[data-v-6611a79a],\nth[data-v-6611a79a],\ntd[data-v-6611a79a] {\n  border: 1px solid black;\n}\nth[data-v-6611a79a] {\n  background-color: #218fc0;\n  color: white;\n  padding: 10px 20px;\n}\ntd[data-v-6611a79a] {\n  padding: 10px 20px;\n}\ncaption[data-v-6611a79a] {\n  caption-side: bottom;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
